import {MI} from "../init";
import AbstractSymbol from "./AbstractSymbol";
import {getArrayRandValue, getRandomInt} from "../../framework/src/helpers";

/**
 * @constructor
 * @extends {AbstractSymbol}
 * @param {MadnesObject} sprite
 * @param {number} symbolNum
 * @param {number} reelX
 * @param {number} reelY
 */
export default function SymbolRing(sprite, symbolNum, reelX, reelY) {
    AbstractSymbol.call(this, sprite, symbolNum, reelX, reelY);

    /** @type {MadnesObject|null} */
    this._winShineObject = null;
    /** @type {MadnesObject|null} */
    this._sparkle = null;

    /** @type {MadnesTween|null} */
    this._standTweenScale = null;
    /** @type {Function|null} */
    this._winAnimResolver = null;

    this._sparklePositions = [
        { 'x': 112, 'y': 32 },
        { 'x': 127, 'y': 173, 'c': 'red' },
        { 'x': 110, 'y': 90 },
        { 'x': 112, 'y': 66 },
        { 'x': 180, 'y': 100 },
        { 'x': 27, 'y': 80 },
        { 'x': 100, 'y': 128, 'c': 'red' },
        { 'x': 203, 'y': 75 }
    ];
};

SymbolRing.prototype = Object.create(AbstractSymbol.prototype);
SymbolRing.prototype.constructor = SymbolRing;

SymbolRing.shineColor = 0xff0018;

/**
 * @returns {number}
 */
SymbolRing.prototype.getShineColor = function() {
    return SymbolRing.shineColor;
};

SymbolRing.prototype.clear = function() {
    //this.parentSprite.setTexture("symbols_atlas");
    this._clearParentSprite();

    this.shineSymbol = null;
    this.destroyShineAnim();

    this._winShineObject = null;
    this._standTweenScale = null;
    this._winAnimResolver = null;

    this.removeChilds();
};

/**
 * @override
 * @returns {AbstractSymbol}
 */
SymbolRing.prototype.createSymbol = function() {
    this.clear();
    this.createImage(0, 0, "symbols_atlas").setFrameName(this.symbolName);
    return this;
};

/**
 * @override
 * @returns {AbstractSymbol}
 */
SymbolRing.prototype.createSimpleSymbol = function() {
    return this.createSymbol();
};

SymbolRing.prototype._createSparkle = function() {
    this._sparkle = this.createImage(0, 0, "symbols_atlas").setFrameName("spark_gold").setVisible(false).setBlend("ADD");
};

SymbolRing.prototype.createStandAnim = function() {
    this.shineSymbol = this.createImage(0, 0, "symbols_atlas").setFrameName(this.symbolName + "_shine").setBlend("ADD");
    this.createShineAnim();

    this._createSparkle();
};

SymbolRing.prototype.playStandAnim = function() {
    this._standAnimLoop();
};

SymbolRing.prototype._standAnimLoop = function() {

    if(!AbstractSymbol.spriteExists(this._sparkle)) {
        return;
    }

    var delay = getRandomInt(500, 1000);
    var duration = getRandomInt(1000, 2000);

    var pos = AbstractSymbol.getRealPosition(getArrayRandValue(this._sparklePositions));

    if(typeof pos['c'] !== 'undefined') {
        this._sparkle.setFrameName("spark_red");
    } else {
        this._sparkle.setFrameName("spark_gold");
    }

    this._sparkle.setPos(pos['x'], pos['y']);
    this._sparkle.setScale(0, 0);
    this._sparkle.setVisible(true);
    this._standTweenScale = MI.addTween();
    this._standTweenScale.to(this._sparkle, { 'x': 1, 'y': 1 }, {
        'scale': true,
        'delay': delay,
        'duration': duration / 2,
        'easing': this._standTweenScale.getEasing("quadratic_out"),
        'callback': () => {
            if(!this._standTweenScale || !AbstractSymbol.spriteExists(this._sparkle)) return;

            this._standTweenScale.to(this._sparkle, { 'x': 0, 'y': 0 }, {
                'scale': true,
                'duration': duration / 2,
                'easing': this._standTweenScale.getEasing("quadratic_in"),
                'callback': () => {
                    this._standAnimLoop();
                }
            });
        }
    });
};

SymbolRing.prototype.stopStandAnim = function() {
    this._standTweenScale && this._standTweenScale.stop();
};

SymbolRing.prototype.fadeOutStandAnim = function() {
    var _self = this;

    MI.addTween().to(this._sparkle, { 'alpha': 0 }, {
        'duration': 200,
        'callback': function() {
            _self.stopStandAnim();
            _self._sparkle.destroy();
            _self._sparkle = null;
        }
    });
};

SymbolRing.prototype.fadeInStandAnim = function() {
    this._createSparkle();
    this.playStandAnim();
};

/**
 * @returns {SymbolRing}
 */
SymbolRing.prototype.createWinSymbol = function() {
    this.createSymbol();

    this._winShineObject = this.createImage(0, 0, "symbol_Ring_atlas")
        .setBlend("ADD").setScale(2, 2).setVisible(false).setAlpha(1);
    this._winShineObject.createAnims();
    this._winShineObject.anims.add("shine", MI.generateFrameNames("symbol_Ring_", 0, 19, "", 5));
    this._winShineObject.anims.addOnComplete(this.winAnimCompleted.bind(this));

    return this;
};

SymbolRing.prototype.winAnimCompleted = function() {
    this._winAnimResolver();
};

SymbolRing.prototype.destroyWinAnim = function() {
    this.stopWinAnim();
    this._winShineObject.destroy();
};

/**
 * @returns {Promise}
 */
SymbolRing.prototype.playWinAnim = function() {

    var _this = this;

    return new Promise(function(res) {

        _this._winAnimResolver = res;

        this._winShineObject.setVisible(true);
        this._winShineObject.anims.play("shine");

    }.bind(this));
};

SymbolRing.prototype.stopWinAnim = function() {
    this._winAnimResolver = null;
    this._winShineObject.anims && this._winShineObject.anims.stop();
};